import { render } from "./Nav.vue?vue&type=template&id=052977e2&scoped=true"
const script = {}

import "./Nav.vue?vue&type=style&index=0&id=052977e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-052977e2"

export default script